export const exampleData = () => {
  return {
    sessions: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 2790, date: '2019-04-08'},
          {count: 2859, date: '2019-04-15'},
          {count: 2915, date: '2019-04-22'},
          {count: 3106, date: '2019-04-29'},
          {count: 3300, date: '2019-05-06'},
          {count: 3412, date: '2019-05-13'},
          {count: 3198, date: '2019-05-20'},
          {count: 2975, date: '2019-05-27'},
          {count: 3027, date: '2019-06-03'},
          {count: 3123, date: '2019-06-10'},
          {count: 3772, date: '2019-06-17'},
          {count: 3852, date: '2019-06-24'},
          {count: 4045, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 3260,
          totalCount: 42374,
        },
        data: [
          {count: 2790, date: '2019-04-08'},
          {count: 2859, date: '2019-04-15'},
          {count: 2915, date: '2019-04-22'},
          {count: 3106, date: '2019-04-29'},
          {count: 3300, date: '2019-05-06'},
          {count: 3412, date: '2019-05-13'},
          {count: 3198, date: '2019-05-20'},
          {count: 2975, date: '2019-05-27'},
          {count: 3027, date: '2019-06-03'},
          {count: 3123, date: '2019-06-10'},
          {count: 3772, date: '2019-06-17'},
          {count: 3852, date: '2019-06-24'},
          {count: 4045, date: '2019-07-01'},
        ],
      },
    },
  };
};
